import { configureStore } from '@reduxjs/toolkit';

import AccountDeviceReducer from './slices/AccountDeviceSlice';
import accountLevelReducer from './slices/AccountLevelSlice';
import AccountManagementReducer from './slices/AccountManagementSlice';
import RevenueSharingReducer from './slices/AccountRevenueSharing';
import AccountStationReducer from './slices/AccountStationSlice';
import AlertsReducer from './slices/AlertsSlice';
import ApprovedElectricityPriceReducer from './slices/ApprovedElectricityPriceSlice';
import ApprovedPricingReducer from './slices/ApprovedPricingSlice';
import ApprovedStationManagementReducer from './slices/ApprovedStationManagementSlice';
import ApprovedStripePayoutsReducer from './slices/ApprovedStripePayoutsSlice';
import RevenueByMonthReducer from './slices/ByMonthRevenueSlice';
import ByTransactionReducer from './slices/ByTransactionSlice';
import CampaignReducer from './slices/CampaignManagementSlice';
import ChargerStatusReducer from './slices/ChargerTypeSlice';
import ChargingPointReducer from './slices/ChargingPointSlice';
import ChargingScheduleReducer from './slices/ChargingScheduleSlice';
import ChargingSessionSlice from './slices/ChargingSessionSlice';
import CustomDashboardReducer from './slices/CustomDashboardSlice';
import DeviceAlertsReducer from './slices/DeviceAlertsSlice';
import DeviceBlockedWebsocketReducer from './slices/DeviceBlockedWebsocketSlice';
import DeviceErrorLogsReducer from './slices/DeviceErrorLogs';
import DeviceManagementReducer from './slices/DeviceManagementSlice';
import DeviceNeverBlockedWebsocketReducer from './slices/DeviceNeverBlockedWebsocketSlice';
import OcppLogsReducer from './slices/DeviceOcppLogsSilce';
import DeviceTransactionReducer from './slices/DeviceTransactionSlice';
import ConsumerChargeCommercialReducer from './slices/EndConsumerChargeCommercial';
import ConsumerChargePersonalReducer from './slices/EndConsumerChargePersonal';
import EndConsumerManagementReducer from './slices/EndConsumerManagementSlice';
import EndConsumerPersonalChargerReducer from './slices/EndConsumerPersonalChargerSlice';
import ConsumerReservationsReducer from './slices/EndConsumerReservations';
import ConsumerScheduleCompletedReducer from './slices/EndConsumerScheduleCompleted';
import ConsumerScheduleUpcomingReducer from './slices/EndConsumerScheduleUpcoming';
import EndConsumerReducer from './slices/EndConsumerSlice';
import ConsumerTransactionHistoryReducer from './slices/EndConsumerTransactionHistory';
import ConsumerGuestChargingReducer from './slices/EnsConsumerGuestCharging';
import FacilitySidePanelReducer from './slices/FacilitySidePanelSlice';
import GuestChargingReducer from './slices/GuestChargingSlice';
import GuestChargingStationReducer from './slices/GuestChargingStationSlice';
import HealthFaultAnalyticsReducer from './slices/HealthFaultAnalyticsReportSlice';
import HistoricalFaultReducer from './slices/HistoricalFaultSlice';
import LayoutReducer from './slices/LayoutSlice';
import MaintenanceScheduleReducer from './slices/MaintenanceScheduleSlice';
import NotificationMessageReducer from './slices/NotificationManagementSlice';
import OcppMessageReducer from './slices/OcppMessageSlice';
import OcppMessageReducerV2 from './slices/OcppMessageSlicev2';
import PageTitleReducer from './slices/PageTitleSlice';
import PaymentManagementReducer from './slices/PaymentManagementSlice';
import PayoutReducer from './slices/PayoutSlice';
import PenaltyAccountListReducer from './slices/PenaltyAccountListSlice';
import PenaltyStationListReducer from './slices/PenaltyStationListSlice';
import transactionListPenaltyReducer from './slices/PenaltyTransactionSlice';
import PendingPricingReducer from './slices/PendingPricingSlice';
import PersonalChargingSessionSlice from './slices/PersonalChargingSessionSlice';
import PersonalDeviceReducer from './slices/PersonalDeviceSlice';
import RejectedElectricityPriceReducer from './slices/RejectedElectricityPriceSlice';
import RejectedPricingReducer from './slices/RejectedPricingSlice';
import RejectedStationManagementReducer from './slices/RejectedStationManagementSlice';
import RejectedStripePayoutsReducer from './slices/RejectedStripePayoutsSlice';
import ReportAlertsPointReducer from './slices/ReportAlertsPointSlice';
import ReportAlertsStationReducer from './slices/ReportAlertsStationSlice';
import ReportBookingPointReducer from './slices/ReportBookingPointSlice';
import ReportBookingStationReducer from './slices/ReportBookingStationSlice';
import ReportsChargerUtilizationPointReducer from './slices/ReportChargerPointSlice';
import ReportsChargerUtilizationStationReducer from './slices/ReportChargerStationSlice';
import ReportEnergyPointReducer from './slices/ReportEnergyPointSlice';
import ReportEnergyStationReducer from './slices/ReportEnergyStationSlice';
import ReportMaintenancePointReducer from './slices/ReportMaintenancePointSlice';
import ReportMaintenanceStationReducer from './slices/ReportMaintenanceStationSlice';
import ReportManagementReducer from './slices/ReportManagementSlice';
import ReportPerformancePointReducer from './slices/ReportPerformancePointSlice';
import ReportPerformanceStationReducer from './slices/ReportPerformanceStationSlice';
import ReportRevenuePointReducer from './slices/ReportRevenuePointSlice';
import ReportRevenueStationReducer from './slices/ReportRevenueStationSlice';
import ReportReducer from './slices/ReportSlice';
import RequestApprovedAccountReducer from './slices/RequestApprovedAccountSlice';
import RequestApprovedStationReducer from './slices/RequestApprovedStationSlice';
import RequestPendingAccountReducer from './slices/RequestPendingAccountSlice';
import RequestPendingStationReducer from './slices/RequestPendingStationSlice';
import RequestRejectedAccountReducer from './slices/RequestRejectedAccountSlice';
import RequestRejectedStationReducer from './slices/RequestRejectedStationSlice';
import RevenueManagementAccountReducer from './slices/RevenueManagementAccountSlice';
import RevenueManagementStationReducer from './slices/RevenueManagementStationSlice';
import RfidCardsReducer from './slices/RfidManagementSlice';
import RoleManagementReducer from './slices/RolesManagementSlice';
import softWareLogsReducer from './slices/SoftWareLogsSlice';
import StationActivityReducer from './slices/StationActivitySlice';
import StationComparisonSlice from './slices/StationComparisonSlice';
import StationDetailsReducer from './slices/StationDetailsSlice';
import stationManagementReducer from './slices/StationManagementSidePanelSlice';
import StationPerformanceReducer from './slices/StationPerformanceSlice';
import StationRevenueSharingReducer from './slices/StationRevenueSharingSlice';
import SummaryReportsReducer from './slices/SummaryReportSlice';
import TableModalReducer from './slices/TableModalSlice';
import TableSidePanelReducer from './slices/TableSidePanelSlice';
import TableTextSizeReducer from './slices/TableTextSizeSlice';
import TransactionStationReducer from './slices/TransactionsStationSlice';
import UnapprovedElectricityPriceReducer from './slices/UnapprovedElectricityPriceSlice';
import UnapprovedStationManagementReducer from './slices/UnapprovedStationManagementSlice';
import UnapprovedStripePayoutsReducer from './slices/UnapprovedStripePayoutsSlice';
import UpcomingMaintenancesReducer from './slices/UpcomingMaintenanceSlice';
import UpTimeReducer from './slices/UpTimeListAndChartSlice';
import UserManagementReducer from './slices/UsersManagementSlice';
import UtilityManagementReducer from './slices/UtilityProviderManagementSlice';
import UtilizationEfficiencyReportReducer from './slices/UtilizationEfficiencyReportSlice';

// Store configure with the reducer
export const store = configureStore({
  reducer: {
    accounts: AccountManagementReducer,
    utility: UtilityManagementReducer,
    customDashboard: CustomDashboardReducer,
    endConsumer: EndConsumerManagementReducer,
    notification: NotificationMessageReducer,
    payments: PaymentManagementReducer,
    chargingSession: ChargingSessionSlice,
    personalChargingSession: PersonalChargingSessionSlice,
    users: UserManagementReducer,
    roles: RoleManagementReducer,
    layout: LayoutReducer,
    approvedStation: ApprovedStationManagementReducer,
    unapprovedStation: UnapprovedStationManagementReducer,
    rejectedStation: RejectedStationManagementReducer,
    reports: ReportManagementReducer,
    approvedPricing: ApprovedPricingReducer,
    pendingPricing: PendingPricingReducer,
    rejectedPricing: RejectedPricingReducer,
    revenueAccount: RevenueManagementAccountReducer,
    revenueStation: RevenueManagementStationReducer,
    revenueSharing: RevenueSharingReducer,
    stationRevenueSharing: StationRevenueSharingReducer,
    ocppMessage: OcppMessageReducer,
    ocppMessageV2: OcppMessageReducerV2,
    chargingPoint: ChargingPointReducer,
    device: DeviceManagementReducer,
    personalDevice: PersonalDeviceReducer,
    chargingSchedule: ChargingScheduleReducer,
    guestCharging: GuestChargingReducer,
    deviceTransaction: DeviceTransactionReducer,
    maintenanceSchedule: MaintenanceScheduleReducer,
    campaign: CampaignReducer,
    deviceAlert: DeviceAlertsReducer,
    rfidCard: RfidCardsReducer,
    ocppLogs: OcppLogsReducer,
    approvedElectricityPrice: ApprovedElectricityPriceReducer,
    unapprovedElectricityPrice: UnapprovedElectricityPriceReducer,
    rejectedElectricityPrice: RejectedElectricityPriceReducer,
    stripePayouts: ApprovedStripePayoutsReducer,
    unapprovedStripePayouts: UnapprovedStripePayoutsReducer,
    rejectedStripePayouts: RejectedStripePayoutsReducer,
    reportData: ReportReducer,
    reportEnergyStation: ReportEnergyStationReducer,
    reportEnergyPoint: ReportEnergyPointReducer,
    reportRevenuePoint: ReportRevenuePointReducer,
    reportRevenueStation: ReportRevenueStationReducer,
    reportBookingStation: ReportBookingStationReducer,
    reportBookingPoint: ReportBookingPointReducer,
    reportChargerPoint: ReportsChargerUtilizationPointReducer,
    reportChargerStation: ReportsChargerUtilizationStationReducer,
    reportPerformanceStation: ReportPerformanceStationReducer,
    reportPerformancePoint: ReportPerformancePointReducer,
    reportMaintenancePoint: ReportMaintenancePointReducer,
    reportMaintenanceStation: ReportMaintenanceStationReducer,
    reportAlertsPoint: ReportAlertsPointReducer,
    reportAlertsStation: ReportAlertsStationReducer,
    tableSidePanel: TableSidePanelReducer,
    deviceBlocked: DeviceBlockedWebsocketReducer,
    deviceNeverBlocked: DeviceNeverBlockedWebsocketReducer,
    chargerStatus: ChargerStatusReducer,
    deviceErrorLogs: DeviceErrorLogsReducer,
    byTransaction: ByTransactionReducer,
    revenueByMonth: RevenueByMonthReducer,
    accountStation: AccountStationReducer,
    accountDevice: AccountDeviceReducer,
    payout: PayoutReducer,
    accountLevel: accountLevelReducer,
    tableTextSize: TableTextSizeReducer,
    accountPenalty: PenaltyAccountListReducer,
    stationPenalty: PenaltyStationListReducer,
    transactionPenalty: transactionListPenaltyReducer,
    requestApprovedAccount: RequestApprovedAccountReducer,
    requestApprovedStation: RequestApprovedStationReducer,
    requestPendingAccount: RequestPendingAccountReducer,
    requestPendingStation: RequestPendingStationReducer,
    requestRejectedAccount: RequestRejectedAccountReducer,
    requestRejectedStation: RequestRejectedStationReducer,
    stationActivity: StationActivityReducer,
    alertsStation: AlertsReducer,
    softWareLogs: softWareLogsReducer,
    HistoricalFault: HistoricalFaultReducer,
    SummaryReports: SummaryReportsReducer,
    UtilizationEfficiencyReport: UtilizationEfficiencyReportReducer,
    HealthFaultAnalyticsReport: HealthFaultAnalyticsReducer,
    transactions: TransactionStationReducer,
    guestChargingStation: GuestChargingStationReducer,
    upcomingMaintenances: UpcomingMaintenancesReducer,
    stationManagement: stationManagementReducer,
    stationDetails: StationDetailsReducer,
    stationPerformance: StationPerformanceReducer,
    stationComparison: StationComparisonSlice,
    UpTime: UpTimeReducer,
    pageTitle: PageTitleReducer,
    tableModal: TableModalReducer,
    ConsumerChargeCommercial: ConsumerChargeCommercialReducer,
    ConsumerChargePersonal: ConsumerChargePersonalReducer,
    ConsumerGuestCharging: ConsumerGuestChargingReducer,
    ConsumerReservations: ConsumerReservationsReducer,
    ConsumerScheduleCompleted: ConsumerScheduleCompletedReducer,
    ConsumerScheduleUpcoming: ConsumerScheduleUpcomingReducer,
    ConsumerTransactionHistory: ConsumerTransactionHistoryReducer,
    ConsumerPersonalCharger: EndConsumerPersonalChargerReducer,
    endConsumerType: EndConsumerReducer,
    facilitySidePanel: FacilitySidePanelReducer,
  },
});

// RootState and AppDispatch types
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
